export default "__VITE_ASSET__a10f7641__"